"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSearch = void 0;
var _reactRedux = require("react-redux");
var _react = require("react");
var _questionnaireSelectors = require("../../store/questionnaire/questionnaireSelectors");
var _useQuestionSelectionActions = require("./useQuestionSelectionActions");
var _lodash = _interopRequireDefault(require("lodash.uniqby"));
var _services = require("../../services");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var useSearch = function useSearch(question, selections) {
  var minCharacters = question.minCharacters;
  var selection = selections[0];
  var _useState = (0, _react.useState)(selection !== null && selection !== void 0 ? selection : ''),
    _useState2 = _slicedToArray(_useState, 2),
    searchText = _useState2[0],
    setSearchText = _useState2[1];
  var handsetSearchList = (0, _reactRedux.useSelector)(_questionnaireSelectors.selectHandsetSearchList);
  var _useQuestionSelection = (0, _useQuestionSelectionActions.useQuestionSelectionActions)(question),
    replaceSelection = _useQuestionSelection.replaceSelection,
    removeSelection = _useQuestionSelection.removeSelection;
  var onChange = function onChange(value) {
    setSearchText(value);
    if (selection) {
      removeSelection(selection);
    }
  };
  var onSelect = function onSelect(choice) {
    if (choice.hasEmptyResults) return;
    replaceSelection(choice.text);
  };
  var onFilter = function onFilter(value, suggestions) {
    // keep only alphanumeric and space characters
    var sanitizedValue = value.replace(/[^a-zA-Z0-9\s]/g, '').trim();
    var terms = sanitizedValue.split(' ').filter(function (term) {
      return term !== '';
    });
    var suggestionRankedArray = [];
    terms.forEach(function (term) {
      //search for every term in the suggestions
      var uniqSuggestions = (0, _lodash.default)(suggestions, function (suggestion) {
        return suggestion.model;
      });
      uniqSuggestions.forEach(function (suggestion) {
        //is the term included in the model or brand?
        if (suggestion.model.toLowerCase().includes(term.toLowerCase()) || suggestion.brand.toLowerCase().includes(term.toLowerCase())) {
          //yes it is so add it to the suggestion array
          var foundItem = suggestionRankedArray.find(function (entry) {
            return entry.name === suggestion.model;
          });
          //is the suggestion already in the array?
          if (foundItem) {
            //Yes it is increase its score as it matches more terms
            foundItem.score++;
          } else {
            //No, Add it to the array
            suggestionRankedArray.push({
              name: suggestion.model,
              score: 1
            });
          }
        }
      });
    });
    return suggestionRankedArray.length ? suggestionRankedArray.sort(function (el1, el2) {
      return el2.score - el1.score;
    }).map(function (entry) {
      return {
        text: entry.name
      };
    }) : [{
      text: _services.locale.localeString('ErrorPage.AddressNotFound', {
        value: value
      }),
      hasEmptyResults: true
    }];
  };
  return {
    handsetSearchList: handsetSearchList,
    searchText: searchText,
    minCharacters: minCharacters,
    onChange: onChange,
    onSelect: onSelect,
    onFilter: onFilter
  };
};
exports.useSearch = useSearch;